/**
 * TF remake bot-part overlay stats (parallel to legacy sand/rock TF1 until that path is removed).
 * Shared by REST config load, Edit Bots / Market, and AGE BotTf create.
 */
export enum StatTypeTf2 {
  seedCapacity = 'seedCapacity',
  skillSize = 'skillSize',
  movementSpeed = 'movementSpeed'
}

/** Ordered skill-size tiers. Add new tiers here; the resolver derives its range from this list. */
export const skillSizeTiers = [1, 2, 3] as const;

export type SkillSizeTier = typeof skillSizeTiers[number];

/** One part row: optional numeric values keyed by {@link StatTypeTf2}. */
export type IBotPartTf2ConfigItem = {
  [K in StatTypeTf2]?: number;
};

export type BotPartsTf2Config = Record<string, IBotPartTf2ConfigItem>;

export type TerraformingPlayerStats = {
  [Key in StatTypeTf2]: {
    ['seedCapacity']: number;
    ['skillSize']: SkillSizeTier;
    ['movementSpeed']: number;
  }[Key];
};
